import CSS from "./static/css/UploadImageContainerViewMode.module.css";
import { viewerImageInterface } from "../../../../Component/Elements/ImageGallery/interface/ImageGallery.interface";
import ReactPhotoSwipeGallery from "../../../../Component/Elements/ReactPhotoSwipeGallery/ReactPhotoSwipeGallery";
import ListCardHeaderText from "../../../../Component/Elements/ListCardHeaderText/ListCardHeaderText";
import EmptyData from "../../../../Component/Elements/EmptyData/EmptyData";
import FolderImageViewer from "../FolderImageViewer/FolderImageViewer";

const UploadImageContainerViewMode = (
    {
        folder_name,
        folder_middle_img_url,
        
        initialImgList,
        isComfrimMode,
        isSingle,
        thumbnail_no_padding,
    }:{
        folder_name: string;
        folder_middle_img_url: string;

        initialImgList: viewerImageInterface[];
        isComfrimMode?: boolean;
        isSingle: boolean;
        thumbnail_no_padding?: boolean;
    }
) => {
    return(
        <div className={CSS.l_UploadImageContainerViewMode_main}>
            {
                !isSingle
                &&  <div className={CSS.l_UploadImageContainerViewMode_header}>
                        <div className={CSS.l_UploadImageContainerViewMode_header_left}>
                            <ListCardHeaderText
                                header_text={folder_name}
                                copy_function_target_text={isComfrimMode ? `[${folder_name}]` : undefined}
                                isSatisfiedPhotoNums={true}
                            />

                            {/* 모바일환경에서의 상세보기 버튼 */}
                            <div className={"g_display_none_object web"}>
                                <FolderImageViewer 
                                    img_src={folder_middle_img_url}
                                    btn_type={"icon"}
                                />
                            </div>
                        </div>

                        {/* PC환경에서의 상세보기 버튼 */}
                        <div className={`g_display_none_object mobile ${CSS.l_UploadImageContainerViewMode_header_right}`}>
                            <FolderImageViewer 
                                img_src={folder_middle_img_url}
                                btn_type={"button"}
                            />
                        </div>
                    </div>
            }

            {
                initialImgList.length > 0
                ?   <ReactPhotoSwipeGallery
                        img_list={initialImgList}
                        isComfrimMode={isComfrimMode}
                        thumbnail_no_padding={thumbnail_no_padding}
                    />
                :   <EmptyData />
            }
        </div>
    )
}

export default UploadImageContainerViewMode;
